/**
 * @file Requests are shown in the out - and inbox of our application.
 * @author Tom Verschoore de la Houssaije
 */
import { RequestTypes } from './request-types';
import { RequestStatus } from './request-status';
/** Request entities are shown in the out - and inbox of our application. */
var Request = /** @class */ (function () {
    function Request() {
        // WARNING: Do not define an id property. Use the PROPERTY_ID constant.
        /**
         * Field to hold the value for the resource property.
         * @private
         * @type {Entity}
         */
        this._resource = null;
        /**
         * Gets, sets the IsRead property.
         * The IsRead property is a server side NotMapped property.
         * That is why it needs a default value forcing Breeze.js to serialize this property.
         */
        this.IsRead = false;
    }
    Object.defineProperty(Request.prototype, "IsExpired", {
        /**
         * Gets whether or not the Request is expired on the current date.
         * @readonly
         * @type {boolean}
         */
        get: function () {
            var currentDate = new Date();
            return this.Expiration < currentDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Request.prototype, "ReadOnly", {
        /**
         * Gets whether or not the Request is read only.
         * The value is derived from the properties IsExpired and Status.
         * @readonly
         * @type {boolean}
         */
        get: function () {
            return this.IsExpired || this.Status !== RequestStatus.Request;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Request.prototype, "SubjectType", {
        /**
         * Gets the short name of the subject entity type based on the request type.
         * @readonly
         * @type {string}
         */
        get: function () {
            switch (this.Type) {
                case RequestTypes.Absence:
                case RequestTypes.AbsenceChanged:
                    return 'Appointment';
                case RequestTypes.ExchangeAssignment:
                case RequestTypes.ReassignAssignment:
                    return 'Assignment';
                case RequestTypes.ExchangeAttendant:
                case RequestTypes.ReassignAttendant:
                    return 'Attendant';
                case RequestTypes.ExchangeDay:
                case RequestTypes.ReassignDay:
                    return 'Day';
                default:
                    return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Request.prototype, "Resource", {
        /**
         * Gets or sets the receiver. Can only be used while creating a request.
         * @type {Entity}
         */
        get: function () {
            return this._resource;
        },
        set: function (value) {
            if (this._resource !== value) {
                this._resource = value;
                this.ReceiverOid = value ? value['Oid'] : '';
            }
        },
        enumerable: true,
        configurable: true
    });
    return Request;
}());
export { Request };
